<template>
  <span
    class="ui-icon"
    :class="[
      `ui-icon--${tone}`,
      {
        'ui-icon--soft': soft,
        'ui-icon--solid': solid,
        'ui-icon--spin': spin,
      },
    ]"
    :style="iconStyle"
    aria-hidden="true"
  >
    <vue-feather :type="name" :size="size" />
  </span>
</template>

<script>
export default {
  name: "HsIcon",
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 18,
    },
    tone: {
      type: String,
      default: "neutral",
      validator: (value) =>
        ["neutral", "primary", "success", "warning", "danger", "info"].includes(value),
    },
    soft: {
      type: Boolean,
      default: false,
    },
    solid: {
      type: Boolean,
      default: false,
    },
    spin: {
      type: Boolean,
      default: false,
    },
    boxSize: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    iconStyle() {
      if (!this.boxSize) return null;
      const value = typeof this.boxSize === "number" ? `${this.boxSize}px` : this.boxSize;
      return {
        height: value,
        width: value,
      };
    },
  },
};
</script>

<style scoped>
.ui-icon {
  align-items: center;
  color: currentColor;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  line-height: 1;
}

.ui-icon--soft,
.ui-icon--solid {
  border-radius: 14px;
  height: 2.5rem;
  width: 2.5rem;
}

.ui-icon--soft.ui-icon--neutral {
  background: color-mix(in srgb, var(--hs-muted, #64748b) 10%, transparent);
  color: var(--hs-muted, #64748b);
}

.ui-icon--soft.ui-icon--primary {
  background: color-mix(in srgb, var(--hs-primary, #3293ec) 12%, transparent);
  color: var(--hs-primary, #3293ec);
}

.ui-icon--soft.ui-icon--success {
  background: color-mix(in srgb, #22c55e 14%, transparent);
  color: #15803d;
}

.ui-icon--soft.ui-icon--warning {
  background: color-mix(in srgb, #f59e0b 16%, transparent);
  color: #b45309;
}

.ui-icon--soft.ui-icon--danger {
  background: color-mix(in srgb, #ef4444 13%, transparent);
  color: #dc2626;
}

.ui-icon--soft.ui-icon--info {
  background: color-mix(in srgb, #06b6d4 14%, transparent);
  color: #0891b2;
}

.ui-icon--solid {
  color: #fff;
}

.ui-icon--solid.ui-icon--neutral {
  background: #111827;
}

.ui-icon--solid.ui-icon--primary {
  background: linear-gradient(135deg, var(--hs-primary, #3293ec), var(--hs-primary-strong, #1d4ed8));
}

.ui-icon--solid.ui-icon--success {
  background: linear-gradient(135deg, #22c55e, #15803d);
}

.ui-icon--solid.ui-icon--warning {
  background: linear-gradient(135deg, #f59e0b, #b45309);
}

.ui-icon--solid.ui-icon--danger {
  background: linear-gradient(135deg, #ef4444, #b91c1c);
}

.ui-icon--solid.ui-icon--info {
  background: linear-gradient(135deg, #06b6d4, #0284c7);
}

.ui-icon--spin {
  animation: ui-spin 0.85s linear infinite;
}

@keyframes ui-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
